// extracted by mini-css-extract-plugin
export var actionButton = "_iz-0";
export var fileInput = "_iz-2";
export var paperclip = "_iz-1";